<template>
  <WayfindingContentLayout />
</template>

<script>
import { useMeta } from 'vue-meta';

import WayfindingContentLayout from '@/components/wayfinding/WayfindingContentLayout.vue';

export default {
  components: {
    WayfindingContentLayout,
  },
  setup() {
    useMeta({
      title: 'My account | Clearco',
    });
  },
};
</script>
